<template>
  <table class="table operative-table" :class="{ 'table-sm': dense, 'sticky': sticky }">
    <slot></slot>
  </table>
</template>

<script>

export default {
  name: 'operative-table',
  props: {
    dense: {
      type: Boolean,
      default: false,
    },
    sticky: {
      type: Boolean,
      default: false,
    },
  },
};

</script>

<style lang="scss">

.operative-table {
  .operative-table-header-column {
    min-width: 250px;
    max-width: 300px;

    @include media-breakpoint-up("md") {
      min-width: 300px;
      max-width: 600px;
    }
  }

  .operative-table-value-column,
  .operative-table-value-column-header,
  .operative-table-body-row-empty td {
    width: calc((100% / 5) + 0px);
    min-width: 100px;
  }

  .operative-table-value-column:first-child,
  .operative-table-value-column-header:first-child,
  .operative-table-body-row-empty td:first-child {
    min-width: 250px;
    max-width: 300px;

    @include media-breakpoint-up("md") {
      min-width: 300px;
      max-width: 600px;
    }
  }

  &.sticky {
    tbody tr > th:first-child {
      position: sticky;
      z-index: 10;

      box-shadow: 7px 0 4px -4px rgba(0,0,0,.3);
      left: 0;
    }

    .operative-table-body-row {
      .operative-table-header-column {
        background: white;
      }
    }

    &.sticky-left {
      box-shadow: 7px 0 4px -4px rgba(0,0,0,.3);
      left: 0;
    }
    // Ricorda che per far funzionare tutto correttamente, ogni cella dovrà avere un background.
    // Gli header lo hanno già (bg-primary), le righe normali no. Basterà aggiungere la classe "bg-white"
  }
}

</style>
